import {API_URL} from '../constants/index.js';
import {
    ADD_GROUP,
    ADD_GROUP_ERROR,
    ADD_GROUP_SUCCESS,
    GET_GROUPS,
    GET_GROUPS_ERROR,
    GET_GROUPS_SUCCESS,
    UPDATE_GROUP,
    UPDATE_GROUP_ERROR,
    UPDATE_GROUP_SUCCESS,
} from '../constants/groupAppsConstants';

import {sweetAlert} from '../components/Alert/sweetAlert'

//POST APP
export function addGroup(data){
    return{
        type: ADD_GROUP,
        data
    }
}

export function addGroupSuccess(data){
return{
    type: ADD_GROUP_SUCCESS,
    data
}
}

export function addGroupError(data){
return{
    type: ADD_GROUP_ERROR,
    data
}
}

export function AddGroup(groupToSave){
const headers ={
    'Content-Type':'application/json' ,
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Authorization': 'Bearer '+localStorage.getItem('token'),
};

const url = `${API_URL}home-apps/AddGroupApp`;

return dispatch => {
    dispatch(addGroup());

    return fetch(url,
    {
        body: JSON.stringify(groupToSave),
        method: 'POST',
        headers:  headers
    })
    .then(res => res.json())
    .then(res => {
        const message ='Group added successfuly';
        const data = (res)? res: undefined;

        dispatch(addGroupSuccess(data));
        sweetAlert('success', message, 'alert_Update_Success');

        return data;
    })
    .catch(error => {
        const message ='Error adding group';
        dispatch(addGroupError(error));
        sweetAlert('error', message, 'alert_Update_Success');
    })
};
}

//GET APPS
export function getGroups(data){
        return{
            type: GET_GROUPS,
            data
        }
}

export function getGroupsSuccess(data){
    return{
        type: GET_GROUPS_SUCCESS,
        data
    }
}

export function getGroupsError(data){
    return{
        type: GET_GROUPS_ERROR,
        data
    }
}

export function GetGroups(communityId){
    const headers ={
        'Content-Type':'application/json' ,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Authorization': 'Bearer '+localStorage.getItem('token'),
        'CommunityId': communityId
    };

    const url = `${API_URL}home-apps/GetAllGroupApps`;

    return  dispatch => {
        dispatch(getGroups());

        return fetch(url,
        {
            method: 'GET',
            headers:  headers
        })
        .then(res => res.json())
        .then(res => {

            const data = (res && res.data)? res.data: undefined;
            dispatch(getGroupsSuccess(data));

            return data;
        })
        .catch(error => {
            dispatch(getGroupsError(error));
        })
    };
}

//UPDATE Group
export function updateGroup(data){
    return{
        type: UPDATE_GROUP,
        data
    }
}

export function updateGroupSuccess(data){
    return{
        type: UPDATE_GROUP_SUCCESS,
        data
    }
}

export function updateGroupError(data){
    return{
        type: UPDATE_GROUP_ERROR,
        data
    }
}

export function UpdateGroup(groupId, updateBody){

    const headers ={
        'Content-Type':'application/json' ,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Authorization': 'Bearer '+localStorage.getItem('token'),
    };

    const url = `${API_URL}home-apps/UpdateGroupApp/${groupId}`;

    return dispatch => {
        dispatch(updateGroup());

        return fetch(url,
        {
            body: JSON.stringify(updateBody),
            method: 'PUT',
            headers:  headers
        })
        .then(() => {
            const message ='Group updated successfully';

            dispatch(updateGroupSuccess({}));
            sweetAlert('success', message, 'alert_Update_Success');

            return {succes:true};
        })
        .catch(error => {
            const message ='Error updating group';
            dispatch(updateGroupError(error));
            sweetAlert('error', message, 'alert_Update_Success');
        })
    };
}

export function UpdateGroupsOrder(communityId, updateGroupsIds){

    const headers ={
        'Content-Type':'application/json' ,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Authorization': 'Bearer '+localStorage.getItem('token'),
        'communityId': communityId,
    };

    const url = `${API_URL}home-apps/UpdateGroupsOrderById`;

    return dispatch => {
        dispatch(updateGroup());

        return fetch(url,
        {
            body: JSON.stringify(updateGroupsIds),
            method: 'PUT',
            headers:  headers
        })
        .then(() =>{

            dispatch(updateGroupSuccess({}));

            return {succes:true};
        })
        .catch(error => {
            dispatch(updateGroupError(error));
        })
    };
}


